module.exports = __webpack_public_path__ + "static/media/manuel1.d24046fc.png";